<template>
    <hts-modal
        :show="show"
        :title="$t('labels.nodeTypeModule.delete')"
        type="confirm"
        :content="$t('labels.nodeTypeModule.confirmDelete')"
        @hide="closeOverSide"
        @confirm="() => handleSubmit()" />
</template>
<script setup lang="ts">
import { $lodash } from '#imports'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  nodeTypeId: {
    type: Object || Array
  }
})

const emits = defineEmits(['close', 'refreshTables'])

const closeOverSide = () => {
  emits('close')
}

const handleSubmit = $lodash.debounce(() => {
  const api = $urlAdmin.node.type.delete
  $api(api, { body: props.nodeTypeId }).then((data) => {
    const resData: any = data?.data?.value

    if (resData.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.deleteSuccess'))
      emits('close')
    }
  })
}, 300)
</script>
